var _circle, _rect, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconWarningRed(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 23.0318,
    cy: 23.0318,
    r: 23,
    transform: "rotate(0.0792175 23.0318 23.0318)",
    fill: "#FEE2E9"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    transform: "translate(9.05115 9.01244) rotate(0.0792175)",
    fill: "#FEE2E9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.0366 19.5318L23.0302 24.1984",
    stroke: "#C4314B",
    strokeWidth: 2.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1355 13.2186L11.6567 28.9952C11.4613 29.3326 11.3576 29.7152 11.3559 30.1051C11.3543 30.4949 11.4547 30.8784 11.6473 31.2174C11.8398 31.5564 12.1177 31.8391 12.4534 32.0373C12.7891 32.2355 13.1709 32.3424 13.5607 32.3474L32.477 32.3735C32.8667 32.3696 33.2486 32.2637 33.5846 32.0664C33.9207 31.8692 34.1993 31.5874 34.3928 31.2491C34.5862 30.9109 34.6878 30.5278 34.6874 30.1382C34.6869 29.7485 34.5845 29.3657 34.3903 29.0278L24.9552 13.2228C24.7567 12.8941 24.4767 12.6221 24.1425 12.4332C23.8082 12.2443 23.4308 12.1447 23.0468 12.1442C22.6628 12.1437 22.2852 12.2422 21.9504 12.4302C21.6156 12.6182 21.3349 12.8893 21.1355 13.2175L21.1355 13.2186Z",
    stroke: "#C4314B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0253 27.6984L23.037 27.6985",
    stroke: "#C4314B",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWarningRed);
export default __webpack_public_path__ + "static/media/Icon_Warning_Red.1c11ff32475a5c09a5eb788a76e5e10e.svg";
export { ForwardRef as ReactComponent };